import type { CacheManagerConfig } from "@/types/cache";

export const CACHE_MANAGER_CONFIG: CacheManagerConfig = {
  cacheMetadataFileName: "cache-manager.json",
  maxAllowedBytes: 2_147_483_648, // 2 Gibibytes
  defaultCacheMetadataContent: {
    bytesUsed: 0,
    cacheItems: [],
  },
};

export const GATEWAY_CACHE_NAME = "gateway-api-cache";
export const GATEWAY_CACHE_VERSION = 1;

export const UNCACHEABLE_GATEWAY_PATH_PATTERN = /\/(users|roles)\/?$/;
